export default __webpack_public_path__ + "static/media/g2022-18.b2030339.jpeg";